// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewSwitch_wrapper__I-Vh6","buttons":"ViewSwitch_buttons__3R05E"};